<template>
  <a-form :model="form" name="basic" autocomplete="off" layout="inline" ref="formStateRef"
          :label-col="{ style: { width: '160px' } }" style="color: #fff;">
    <div class="freqx_formTitle">{{ getLanguage('智能诊断报警', language) }}</div>
    <a-form-item :label="getLanguage('可用报警') + '(' + getLanguage('秒') + ')' ">
      <a-input-number v-model:value="form.level1IntervalSeconds" min="-1"/>
    </a-form-item>
    <a-form-item :label="getLanguage('警戒报警') + '(' + getLanguage('秒') + ')' ">
      <a-input-number v-model:value="form.level2IntervalSeconds" min="-1"/>
    </a-form-item>
    <a-form-item :label="getLanguage('故障报警') + '(' + getLanguage('秒') + ')' ">
      <a-input-number v-model:value="form.level3IntervalSeconds" min="-1"/>
    </a-form-item>

    <div class="freqx_formTitle">{{ getLanguage('门限报警', language) }}</div>

    <a-form-item :label="getLanguage('可用报警') + '(' + getLanguage('秒') + ')' ">
      <a-input-number v-model:value="form.thresholdLevel1IntervalSeconds" min="-1"/>
    </a-form-item>
    <a-form-item :label="getLanguage('警戒报警') + '(' + getLanguage('秒') + ')' ">
      <a-input-number v-model:value="form.thresholdLevel2IntervalSeconds" min="-1"/>
    </a-form-item>
    <a-form-item :label="getLanguage('故障报警') + '(' + getLanguage('秒') + ')' ">
      <a-input-number v-model:value="form.thresholdLevel3IntervalSeconds" min="-1"/>
    </a-form-item>

    <div style="width: 100%;text-align: center" class="mt-4">
      <a-button type="primary" @click="onSubmit">{{ getLanguage('提交') }}</a-button>
    </div>


  </a-form>
</template>

<script lang="ts" setup>
import { defineProps, onMounted, ref } from "vue";
import { v4 as uuidv4 } from "uuid";
import request from "@/common/request";
import { getLanguage } from "@/common/translate";
import { message } from "ant-design-vue";
import { operateLogs } from "@/common/logs";

let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
}
getLang()

const props = defineProps<{ factoryId?: string | null }>();
const emit = defineEmits(['success']);

let _factoryId: string | null;
onMounted(() => {
  _factoryId = props.factoryId || null;
  if (_factoryId == null) {
    _factoryId = localStorage.getItem('factory_id') || null
  }
  if (_factoryId) {
    getFactorySettings(_factoryId);
  }
});

class AlarmBeepSettings {
  level1IntervalSeconds: number = 5;
  level2IntervalSeconds: number = 5;
  level3IntervalSeconds: number = 5;

  thresholdLevel1IntervalSeconds: number = 5;
  thresholdLevel2IntervalSeconds: number = 5;
  thresholdLevel3IntervalSeconds: number = 5;
}

let form = ref<AlarmBeepSettings>(new AlarmBeepSettings());

let isIntervalSet = function (settings: AlarmBeepSettings) {
  return settings.level1IntervalSeconds
      || settings.level2IntervalSeconds
      || settings.level3IntervalSeconds
      || settings.thresholdLevel1IntervalSeconds
      || settings.thresholdLevel2IntervalSeconds
      || settings.thresholdLevel3IntervalSeconds
}
const getFactorySettings = (factoryId: string) => {
  const config = {
    params: { id: factoryId },
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/factories/setting", config).then((res: any) => {
    if (res?.data?.alarmBeepSettings) {
      form.value = res.data.alarmBeepSettings;
      if (!isIntervalSet(form.value)) {
        form.value = new AlarmBeepSettings()
      }
    } else {
      form.value = new AlarmBeepSettings();
    }
  });
};

function onSubmit() {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  let settings = Object.assign({}, form.value);
  let body = {
    factoryId: _factoryId,
    alarmBeepSettings: settings
  }
  request.post("/api/factories/setting", body, config).then((res: any) => {
    if (res?.status == 200) {
      operateLogs("修改基础配置");
      message.success(getLanguage('提交成功', language.value));
      emit('success')
    }
  });
}


</script>

<style scoped lang="less">

</style>
